import { render, staticRenderFns } from "./NewNoteDialog.vue?vue&type=template&id=6e1f031a&scoped=true"
import script from "./NewNoteDialog.vue?vue&type=script&lang=js"
export * from "./NewNoteDialog.vue?vue&type=script&lang=js"
import style0 from "./NewNoteDialog.vue?vue&type=style&index=0&id=6e1f031a&prod&lang=scss&scoped=true"
import style1 from "./NewNoteDialog.vue?vue&type=style&index=1&id=6e1f031a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1f031a",
  null
  
)

export default component.exports